import './toggler.less';

import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Tipsy from './tipsy.jsx';
import classNames from 'classnames';

// This was manually extracted from
// https://github.com/instructure-react/zf-react-toggle/
// may god have mercy on our souls

class Toggle extends Component {

  constructor(props) {
    super(props);

    let checked = false;
    if ('checked' in props) {
      checked = props.checked;
    } else if ('defaultChecked' in props) {
      checked = props.defaultChecked;
    }

    this.state = {
      checked: !!checked,
      hasFocus: false
    };

    this.input = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if ('checked' in nextProps) {
      this.setState({ checked: !!nextProps.checked });
    }
  }

  handleClick(event) {
    var checkbox = $(this.input);
    if (event.target !== checkbox) {
      event.preventDefault();
      checkbox.focus();
      checkbox.click();
      return;
    }

    if (!('checked' in this.props)) {
      this.setState({ checked: checkbox.checked });
    }
  }

  handleFocus() {
    this.setState({ hasFocus: true });
  }

  handleBlur() {
    this.setState({ hasFocus: false });
  }

  render() {
    var classes = classNames(
      'zf-react-toggle',
      this.props.className,
      {
        'zf-react-toggle--checked': this.state.checked,
        'zf-react-toggle--focus': this.state.hasFocus,
        'zf-react-toggle--disabled': this.props.disabled
      }
    );

    const inputProps = { ...this.props };
    delete inputProps.disabledReason;
    delete inputProps.className;

    const content = (
      <div
        tabIndex="0"
        role="checkbox"
        aria-checked={this.state.checked ? 'true' : 'false'}
        aria-labelledby={this.props['aria-labelledby'] ? this.props['aria-labelledby'] : null}
        className={classes}
        style={this.props.style}
        onClick={this.handleClick}
        onKeyUp={(e)=> {
          if (e.keyCode === 13 || e.keyCode === 32) {
            this.handleClick(e);
          }
        }}
      >
        <div className='zf-react-toggle-track'>
          <div className='zf-react-toggle-track-check'>
          </div>
          <div className='zf-react-toggle-track-x'>
          </div>
        </div>
        <div className='zf-react-toggle-thumb'>
        </div>
        <input 
          ref={(el) => { this.input = el; }}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          className='zf-react-toggle-screenreader-only'
          type='checkbox'
          {...inputProps} />
      </div>
    );

    if (this.props.disabledReason) {
      return (
        <Tipsy content={this.props.disabledReason}>{content}</Tipsy>
      );
    }

    return content;
  }
}

Toggle.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  'aria-labelledby': PropTypes.string,
  'aria-label': PropTypes.string,
  disabled: PropTypes.bool,
  disabledReason: PropTypes.string
};

export default Toggle;
